/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Studio_Not_FoundInputs */

const en_ui_studio_not_found = /** @type {(inputs: Ui_Studio_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Route not found.`)
};

const de_ui_studio_not_found = /** @type {(inputs: Ui_Studio_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Route nicht gefunden.`)
};

/**
* | output |
* | --- |
* | "Route not found." |
*
* @param {Ui_Studio_Not_FoundInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_studio_not_found = /** @type {((inputs?: Ui_Studio_Not_FoundInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Studio_Not_FoundInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_studio_not_found(inputs)
	return de_ui_studio_not_found(inputs)
});